import { BackedBy } from "../components/BackedBy";
import { Earn } from "../components/Earn";
import { Efficiency } from "../components/Efficiency";
import { Home } from "../components/Home";
import { Makers } from "../components/Makers";
import { Security } from "../components/Security";
import { Takers } from "../components/Takers";

export const LandingPage = () => {
  return (
    <div className="main">
      <Home />
      <Takers />
      <Makers />
      <Earn />
      <Security />
      <Efficiency />
      <BackedBy />
    </div>
  );
};
